import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ColorRing } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';

import EncsChartTitle from '../../EncsChartTitle/EncsChartTitle';

import { createVsFixEncsPerMonthChartOptions } from './createVsFixEncsPerMonthChartOptions';

import { Period } from 'components/AnalyticsPage/Periods';
import { useGetCreatedVsFixedPerMonthChart } from 'hooks/Analitics/EncCharts/useGetCreatedVsFixedPerMonthChart';
import { CreatedVsFixedPerMonthChartData } from 'api/analitics/EncCharts/types';

interface ChartProps {
  slug: string;
}

const CreateVsFixEncsPerMonthChart: React.FC<ChartProps> = ({ slug }) => {
  const [period, setPeriod] = useState<Period>(Period.THREE_MONTH);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [showCustom, setShowCustom] = useState<boolean>(false);
  const { t } = useTranslation();
  const { data, isLoading, isFetching } = useGetCreatedVsFixedPerMonthChart(slug, startDate, endDate);
  const chartOptions = createVsFixEncsPerMonthChartOptions(data as CreatedVsFixedPerMonthChartData, t);

  return (
    <div className="card m-0 border border-2 rounded-4 position-relative">
      <div className="card-header rounded-4">
        <EncsChartTitle
          title={t('ChartsAnalitics.encounters_charts.create_vs_fixed.title')}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          period={period}
          setPeriod={setPeriod}
          showCustom={showCustom}
          setShowCustom={setShowCustom}
        />
      </div>
      <div className="card-body">
        <div className="position-relative">
          {isLoading || isFetching ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '350px' }}>
              <ColorRing
                visible
                height="80"
                width="80"
                ariaLabel="color-ring-loading"
                wrapperStyle={{}}
                wrapperClass="color-ring-wrapper"
                colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
              />
            </div>
          ) : (
            <ReactApexChart options={chartOptions} series={chartOptions.series} type="bar" height={350} />
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateVsFixEncsPerMonthChart;
